import { Col, Row, Tag } from "antd";
import { useSelector } from "react-redux";
import { formatDateAndTime } from "../../../../Common/Utils";
import SYNC from "../../../../../assets/images/icons/sync.svg";
import USER from "../../../../../assets/images/user.svg";
import RIDE from "../../../../../assets/images/icons/ride.svg";
import CardCollapse from "../../../../Common/CardCollapse";
import { UNITS } from "../../../../Common/Constants";

const RideAnalytics = () => {
  const testRide = useSelector((state) => state.testRide);
  const rideDetails = testRide?.tripSummary?.rideForm;

  return (
    <CardCollapse
      cardClassName="ride-statistic-analytics-card"
      icon={RIDE}
      title={"Ride Conditions"}
    >
      <Row gutter={[16, 16]} className="pd05">
        <Col xs={24} sm={24} md={8} lg={6} xl={6} className="box mr1">
          <Row gutter={[16, 16]} justify="center">
            <Col>
              <img src={USER} alt="User" width="60px" />
            </Col>
          </Row>
          <Row gutter={[16, 16]} justify="center">
            <Col className="label">{rideDetails?.riderName}</Col>
          </Row>
          <Row gutter={[16, 16]} className="mt1" justify="end">
            <Col span={10} className="label">
              Ride Time:{" "}
            </Col>
            <Col span={14} className="value">
              <div>{formatDateAndTime(rideDetails?.startTime)}</div>
              <div>
                <img src={SYNC} alt="Sync" />
              </div>
              <div>{formatDateAndTime(rideDetails?.stopTime)}</div>
            </Col>
          </Row>
          {rideDetails?.rideStartPlaceName && rideDetails?.rideEndPlaceName && (
            <Row gutter={[16, 16]} className="mt1" justify="end">
              <Col span={10} className="label">
                Location:{" "}
              </Col>
              <Col span={14} className="value">
                <div>{rideDetails?.rideStartPlaceName}</div>
                <div>
                  <img src={SYNC} alt="Sync" />
                </div>
                <div>{rideDetails?.rideEndPlaceName}</div>
              </Col>
            </Row>
          )}
          <Row gutter={[16, 16]} className="mt1" justify="end">
            <Col span={10} className="label">
              Rider Weight:
            </Col>
            <Col span={14} className="value">
              {rideDetails?.riderWeight}kg
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt1" justify="end">
            <Col span={10} className="label">
              Pillion Rider Name:
            </Col>
            <Col span={14} className="value">
              {rideDetails?.pillionRiderName}
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt1" justify="end">
            <Col span={10} className="label">
              Pillion Rider Weight:
            </Col>
            <Col span={14} className="value">
              {rideDetails?.pillionRiderWeight}kg
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt1" justify="end">
            <Col span={10} className="label">
              Total Weight:
            </Col>
            <Col span={14} className="value">
              {rideDetails?.totalWeight}kg
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={14} lg={16} xl={16}>
          <Row gutter={[16, 2]}>
            <Col span={24} className="bold mt05">
              Battery Details :
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Manufacturer:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.batteryManufacturer}
                </Col>
              </Row>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Capacity:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.batteryCapacity}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Model:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.batteryModel}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row gutter={[16, 2]} className="mt1">
            <Col span={24} className="bold">
              Before Ride :
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Ambient Temperature:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsBeforeRide?.ambientTemperature} {UNITS.CELSIUS}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  MCU Temperature:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsBeforeRide?.mcuTemperature} {UNITS.CELSIUS}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Motor Temperature:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsBeforeRide?.motorTemperature} {UNITS.CELSIUS}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Battery Temperature:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsBeforeRide?.batteryTemperature} {UNITS.CELSIUS}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Battery Percentage:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsBeforeRide?.batteryPercentage} {UNITS.PERCENT}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Battery Voltage:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsBeforeRide?.batteryVoltage} {UNITS.VOLTS}
                </Col>
              </Row>
            </Col>
          </Row>
        
          <Row gutter={[16, 2]} className="mt1">
            <Col span={24} className="bold">
              After Ride :
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Ambient Temperature:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsAfterRide?.ambientTemperature} {UNITS.CELSIUS}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  MCU Temperature:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsAfterRide?.mcuTemperature} {UNITS.CELSIUS}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Motor Temperature:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsAfterRide?.motorTemperature} {UNITS.CELSIUS}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Battery Temperature:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsAfterRide?.batteryTemperature} {UNITS.CELSIUS}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Battery Percentage:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsAfterRide?.batteryPercentage} {UNITS.PERCENT}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Battery Voltage:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.vehicleDetailsAfterRide?.batteryVoltage} {UNITS.VOLTS}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row gutter={[16, 4]} className="mt1">
            <Col span={24} className="bold">
              Notes :
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 16]} justify="end">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Distance:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.distance}km
                </Col>
              </Row>
              <Row gutter={[16, 6]} justify="end">
                <Col xs={14} sm={24} md={24} lg={14} xl={11} xxl={10} className="label">
                  Road Condition:
                </Col>
                <Col xs={10} sm={22} md={22} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.roadCondition.map((item, index) => (
                    <Tag key={index}>{item}</Tag>
                  ))}
                </Col>
              </Row>
              <Row gutter={[16, 6]} justify="end mt05">
                <Col xs={14} sm={24} md={24} lg={14} xl={11} xxl={10} className="label">
                  Traffic:
                </Col>
                <Col xs={10} sm={22} md={22} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.traffic.map((item, index) => (
                    <Tag key={index}>{item}</Tag>
                  ))}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 6]} justify="end mt05">
                <Col xs={14} sm={16} md={18} lg={14} xl={11} xxl={10} className="label">
                  Flyovers:
                </Col>
                <Col xs={10} sm={8} md={6} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.flyoverCount}
                </Col>
              </Row>
              <Row gutter={[16, 6]} justify="end">
                <Col xs={14} sm={24} md={24} lg={14} xl={11} xxl={10} className="label">
                  Climate Condition:
                </Col>
                <Col xs={10} sm={24} md={24} lg={10} xl={13} xxl={14} className="value">
                  {rideDetails?.climateCondition.map((item, index) => (
                    <Tag key={index}>{item}</Tag>
                  ))}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="mt1">
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 6]} justify="end">
                <Col xs={14} sm={24} md={24} lg={14} xl={11} xxl={10} className="label">
                  Observation Parameters:
                </Col>
                <Col xs={10} sm={24} md={24} lg={10} xl={13} xxl={14}>
                  <span className="value text-justify mr1">
                    {rideDetails?.observationParameters?.join(", ")}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 6]} justify="end">
                <Col xs={14} sm={24} md={24} lg={14} xl={11} xxl={10} className="label">
                  Issues:
                </Col>
                <Col xs={10} sm={24} md={24} lg={10} xl={13} xxl={14}>
                  <span className="value text-justify mr1">
                    {rideDetails?.issues?.join(", ")}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="mt1">
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 8]} justify="end">
                <Col span={24} className="label bold">
                  Goal:
                </Col>
                <Col span={24}>
                  <span className="value text-justify pl1 mr1">
                    {rideDetails?.goal}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Row gutter={[16, 8]} justify="end">
                <Col span={24} className="label bold">
                  Comments:
                </Col>
                <Col span={24}>
                  <span className="value text-justify pl1 mr1">
                  {rideDetails?.comment}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </CardCollapse>
  );
};

export default RideAnalytics;
